import { createTheme } from '@mui/material';
import colors from '../colors';
import radius from '../radius';

const theme = createTheme({
  ...colors,
  ...radius,
});

const accordion = {
  MuiAccordion: {
    styleOverrides: {
      root: {
        '&.Mui-expanded': {
          margin: 0,
        },

        '&.MuiPaper-root': {
          border: `1px solid ${theme.palette.primary.main}`,
          borderRadius: theme.radius.md,
          boxShadow: 'none',
          padding: 0,
        },

        '.MuiAccordionSummary-root': {
          borderRadius: theme.radius.md,
          minHeight: '50px !important',
          transition: 'background-color 0.3s ease-in',

          '&:hover': {
            backgroundColor: theme.palette.neutral.light,
          },
        },

        '.MuiAccordionSummary-content.Mui-expanded': {
          margin: 0,
        },
      },
    },
  },
};

export default accordion;
